// extracted by mini-css-extract-plugin
export default {"title":"ReportTitle_title__ZT2hX","titleWrapper":"ReportTitle_titleWrapper__8PXq8","tag":"ReportTitle_tag__xOZo0"};